import { UsedProductsFeatureds } from "@/@types";

type Props = {
    usedProductsFeatured: UsedProductsFeatureds[];
}

export default function UsedProductsFeatured({ usedProductsFeatured }: Props) {
    if (!usedProductsFeatured || usedProductsFeatured.length === 0) {
        return null;
    }

  return (
    <div>
      <h1>Featured Used Products</h1>
      <pre>{JSON.stringify(usedProductsFeatured, null, 2)}</pre>
    </div>
  );
}
